import bService from './base-api'
import { CONTRACT_MANAGER_URL } from '../configs/service-url'

const list = async (filter) => {
  const url = CONTRACT_MANAGER_URL.SPECIAL_OFFER
  const result = await bService.post(url, filter)

  return result
}

const save = async (data) => {
  const url = CONTRACT_MANAGER_URL.SPECIAL_OFFER
  const result = await bService.put(url, data)

  return result
}

const initData = async (hotelId) => {
  const specialOfferUrl = CONTRACT_MANAGER_URL.SPECIAL_OFFER
  const url = `${specialOfferUrl}/init/${hotelId}`

  const result = await bService.get(url)

  return result
}

const detail = async (specialOfferId) => {
  const specialOfferUrl = CONTRACT_MANAGER_URL.SPECIAL_OFFER
  const url = `${specialOfferUrl}/${specialOfferId}`
  const result = await bService.get(url)

  return result
}

const remove = async (specialOfferId) => {
  const specialOfferUrl = CONTRACT_MANAGER_URL.SPECIAL_OFFER
  const url = `${specialOfferUrl}/${specialOfferId}`
  const result = await bService.remove(url)

  return result
}

const updateStatus = async (data) => {
  const specialOfferUrl = CONTRACT_MANAGER_URL.SPECIAL_OFFER
  const url = `${specialOfferUrl}/status`
  const result = await bService.put(url, data)

  return result
}

const generateDocument = async (specialOfferId, data) => {
  const specialOfferUrl = CONTRACT_MANAGER_URL.SPECIAL_OFFER
  const url = `${specialOfferUrl}/generate-document/${specialOfferId}`
  const result = await bService.post(url, data)

  return result
}

const promotionDetail = async (data) => {
  const specialOfferUrl = CONTRACT_MANAGER_URL.SPECIAL_OFFER
  const url = `${specialOfferUrl}/promotion`
  const result = await bService.post(url, data)

  return result
}

const uploadSignedDocument = async (specialOfferId, data) => {
  const specialOfferUrl = CONTRACT_MANAGER_URL.SPECIAL_OFFER
  const url = `${specialOfferUrl}/upload-signed-document/${specialOfferId}`

  const result = await bService.post(url, data)

  return result
}

const downloadSignedDocument = async (data) => {
  const specialOfferUrl = CONTRACT_MANAGER_URL.SPECIAL_OFFER
  const url = `${specialOfferUrl}/download-signed-document`

  const result = await bService.post(url, data)

  return result
}

export default {
  list,
  save,
  detail,
  initData,
  remove,
  updateStatus,
  generateDocument,
  promotionDetail,
  downloadSignedDocument,
  uploadSignedDocument
}
